import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import DynamicInput from "../feilds/dynamic-input";
import { useSelector } from "react-redux";
import { RootState } from "store";

const OrganisationDetailsForm = ({ formik }: any) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const getOrganisationdetails = useSelector(
    (state: RootState) => state.merchantForm.organisationDetails
  ) as any;

  if (getOrganisationdetails.verificationType === "udyam") {
    return (
      <Box
        sx={{
          width: "100%",
          px: { xs: 1, sm: 0, md: 0 },
          "& .MuiFormControl-root": {
            width: "100%",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection={{ xs: "column", lg: "row" }}
          gap={2}
          sx={{
            mb: { xs: 1, sm: 2 },
            width: "100%",
          }}
        >
          <DynamicInput
            formik={formik}
            name="merchantType"
            label="Merchant Type"
            type="text"
            placeholder="Enter Merchant Type"
            value={getOrganisationdetails?.type_of_organisation}
            disabled={true}
          />
          <DynamicInput
            formik={formik}
            name="businessNature"
            label="Business Nature"
            type="text"
            value={getOrganisationdetails?.major_activity}
            placeholder="Enter Business Nature"
            disabled={true}
          />
        </Box>

        <Box
          display="flex"
          flexDirection={{ xs: "column", lg: "row" }}
          gap={2}
          sx={{
            mb: { xs: 1, sm: 2 },
            width: "100%",
          }}
        >
          <DynamicInput
            formik={formik}
            name="owner_name"
            label="Owner Name"
            type="text"
            placeholder="Enter Owner Name"
            value={getOrganisationdetails?.owner_name}
            disabled={true}
          />
          <DynamicInput
            formik={formik}
            name="legalName"
            label="Legal Name"
            type="text"
            value={getOrganisationdetails?.name_of_enterprise}
            placeholder="Enter Legal Name"
            disabled={true}
          />
          
        </Box>

        <Box
          display="flex"
          flexDirection={{ xs: "column", lg: "row" }}
          gap={2}
          sx={{
            mb: { xs: 1, sm: 2 },
            width: "100%",
          }}
        >
          <DynamicInput
            formik={formik}
            name="brandName"
            label="Brand Name*"
            type="text"
            value={getOrganisationdetails?.brandName}
            placeholder="Enter Brand Name"
            secondaryText="(Will be shown on app)"
          />
          <DynamicInput
            formik={formik}
            name="type_of_enterprise"
            label="Type of Enterprise"
            type="text"
            value={getOrganisationdetails?.type_of_enterprise}
            placeholder="Enter Type of Enterprise"
            disabled={true}
          />
          
        </Box>

        <Box
          display="flex"
          flexDirection={{ xs: "column", lg: "row" }}
          gap={2}
          sx={{
            mb: { xs: 1, sm: 2 },
            width: "100%",
          }}
        >
          <DynamicInput
            formik={formik}
            name="registeredAddress"
            label="Registered Address"
            type="text"
            value={getOrganisationdetails?.formatedAddress || getOrganisationdetails?.primary_business_address?.registered_address}
            placeholder="Enter Registered Address"
            disabled={true}
          />
          <DynamicInput
            formik={formik}
            name="cin"
            value={getOrganisationdetails?.cin}
            label="CIN"
            type="text"
            placeholder="Enter CIN"
          />
        </Box>

        <Box
          display="flex"
          flexDirection={{ xs: "column", lg: "row" }}
          gap={2}
          sx={{
            mb: { xs: 1, sm: 2 },
            width: "100%",
          }}
        >
          
          <DynamicInput
            formik={formik}
            name="gstNumber"
            value={getOrganisationdetails?.gstNumber}
            label="GST Number"
            type="text"
            placeholder="Enter GST Number"
          />
        </Box>
        <Typography 
          variant={isMobile ? "body2" : "body1"} 
          color="textSecondary" 
          mt={2}
          fontSize={isMobile ? 13 : 16}
          textAlign={isMobile ? "center" : "left"}
          sx={{ px: { xs: 1, sm: 0 } }}
        >
          Press Submit to submit your Organisation details.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        px: { xs: 1, sm: 0, md: 0 },
        "& .MuiFormControl-root": {
          width: "100%",
        },
      }}
    >
      <Box
        display="flex"
        flexDirection={{ xs: "column", lg: "row" }}
        gap={2}
        sx={{
          mb: { xs: 1, sm: 2 },
          width: "100%",
        }}
      >
        <DynamicInput
          formik={formik}
          name="merchantType"
          label="Merchant Type"
          type="text"
          placeholder="Enter Merchant Type"
          value={getOrganisationdetails?.business_constitution}
          disabled={true}
        />
        <DynamicInput
          formik={formik}
          name="businessNature"
          label="Business Nature"
          type="text"
          value={
            getOrganisationdetails?.primary_business_address?.business_nature
          }
          placeholder="Enter Business Nature"
          disabled={true}
        />
      </Box>

      <Box
        display="flex"
        flexDirection={{ xs: "column", lg: "row" }}
        gap={2}
        sx={{
          mb: { xs: 1, sm: 2 },
          width: "100%",
        }}
      >
        <DynamicInput
          formik={formik}
          name="brandName"
          label="Brand Name*"
          type="text"
          value={getOrganisationdetails?.brandName}
          placeholder="Enter Brand Name"
          secondaryText="(Will be shown on app)"
        />
        <DynamicInput
          formik={formik}
          name="legalName"
          label="Legal Name"
          type="text"
          value={getOrganisationdetails.legal_name}
          placeholder="Enter Legal Name"
          disabled={true}
        />
      </Box>

      <Box
        display="flex"
        flexDirection={{ xs: "column", lg: "row" }}
        gap={2}
        sx={{
          mb: { xs: 1, sm: 2 },
          width: "100%",
        }}
      >
        <DynamicInput
          formik={formik}
          name="gstType"
          label="GST Type"
          type="text"
          value={getOrganisationdetails?.tax_payer_type}
          placeholder="Enter GST Type"
          disabled={true}
        />
        <DynamicInput
          formik={formik}
          name="gstStatus"
          label="GST Status"
          type="text"
          value={getOrganisationdetails?.current_registration_status}
          placeholder="Enter GST Status"
          disabled={true}
        />
      </Box>

      <Box
        display="flex"
        flexDirection={{ xs: "column", lg: "row" }}
        gap={2}
        sx={{
          mb: { xs: 1, sm: 2 },
          width: "100%",
        }}
      >
        <DynamicInput
          formik={formik}
          name="registeredAddress"
          label="Registered Address"
          type="text"
          value={
            getOrganisationdetails?.primary_business_address?.registered_address
          }
          placeholder="Enter Registered Address"
          disabled={true}
        />
        <DynamicInput
          formik={formik}
          name="cin"
          value={getOrganisationdetails?.cin}
          label="CIN"
          type="text"
          placeholder="Enter CIN"
        />
      </Box>

      <Box
        display="flex"
        flexDirection={{ xs: "column", lg: "row" }}
        gap={2}
        sx={{
          mb: { xs: 1, sm: 2 },
          width: "100%",
        }}
      >
        <DynamicInput
          formik={formik}
          name="authorisedSignatory"
          label="Authorised Signatory"
          type="text"
          value={getOrganisationdetails?.authorized_signatory}
          placeholder="Enter Authorised Signatory"
          disabled={true}
        />
        <DynamicInput
          formik={formik}
          name="udhyamNumber"
          value={getOrganisationdetails?.udhyamNumber}
          label="Udyam Number (MSME)"
          type="text"
          placeholder="Enter Udyam Number (MSME)"
        />
      </Box>
      <Typography 
        variant={isMobile ? "body2" : "body1"} 
        color="textSecondary" 
        mt={2}
        fontSize={isMobile ? 13 : 16}
        textAlign={isMobile ? "center" : "left"}
        sx={{ px: { xs: 1, sm: 0 } }}
      >
        Press Submit to submit your Organisation details.
      </Typography>
    </Box>
  );
};

export default OrganisationDetailsForm;
